import { render, staticRenderFns } from "./BaseFiltersSorting.vue?vue&type=template&id=7c78f7d7&"
import script from "./BaseFiltersSorting.vue?vue&type=script&lang=js&"
export * from "./BaseFiltersSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c78f7d7')) {
      api.createRecord('7c78f7d7', component.options)
    } else {
      api.reload('7c78f7d7', component.options)
    }
    module.hot.accept("./BaseFiltersSorting.vue?vue&type=template&id=7c78f7d7&", function () {
      api.rerender('7c78f7d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseFiltersSorting.vue"
export default component.exports